const config = {
    appName: 'Sinbi Chat',
    messageExpirationTime: 24 * 60 * 60 * 1000, // 24 hours
    fileUploadMaxSize: 20 * 1024 * 1024, // 20MB
};

export default config;